@if (manifestCleared()) {
  <span class="fa fa-lock mx-2 text-secondary" title="Manifest has been closed by customs"></span>
}

@if (clearanceDifference()) {
  <span class="fa fa-lock-open mx-2 text-danger" title="Contains clearance differences"></span>
}

@if (inspections(); as inspections) {
  @if (getInspectionState(inspections); as inspectionState) {
    <app-tooltip class="formGroupLabel" [wide]="true" placement="left" [keepOpen]="keepTooltipOpen">
      @if (!inspectionState.deleted) {
        @for (type of inspectionState.inspecting; track type) {
          <span>
            @switch (type) {
              @case ('physical') {
                <span class="fas fa-eye mx-2"></span>
              }
              @case ('scan') {
                <span class="fas fa-camera mx-2"></span>
              }
              @case ('block') {
                <span class="fas fa-hand-paper mx-2"></span>
              }
            }
          </span>
        }
        @for (type of inspectionState.released; track type) {
          <span>
            @switch (type) {
              @case ('physical') {
                <span class="fas fa-eye text-success mx-2"></span>
              }
              @case ('scan') {
                <span class="fas fa-camera text-success mx-2"></span>
              }
              @case ('block') {
                <span class="fas fa-thumbs-up text-success mx-2"></span>
              }
            }
          </span>
        }
      }
      @if (inspectionState.deleted) {
        <span><span class="fas fa-trash-alt text-success mx-2" title="Inspection deleted"></span></span>
      }
      <div class="tooltipContent mt-n2 text-start ">
        @for (inspection of inspections; track inspection) {
          @if (inspection) {
            <div>
              <div class="row narrow-gutters mt-2">
                @if (inspection.containerNumber) {
                  <div class="col-auto" style="color:#C0C0C0;">
                    Inspection status for <span class="text-white">{{ inspection.consignmentNumber }}</span> - <span
                    class="text-white">{{ inspection.containerNumber }}</span></div>
                }
                @if (!inspection.containerNumber) {
                  <div class="col-auto" style="color:#C0C0C0;">
                    Bulk inspection status for <span class="text-white">{{ inspection.consignmentNumber }}</span></div>
                }
              </div>
              @for (update of inspection.inspectionUpdates.slice().reverse(); track update) {
                <div class="row narrow-gutters">
                  <div class="col-auto" style="color:#C0C0C0;">{{ update.timestamp | date:"MMM d HH:mm" }}</div>
                  @if (update.status) {
                    <div class="col-auto">
                      {{ update.status }}{{ update.remark ? ', remark: ' + update.remark : '' }}
                    </div>
                  }
                  @if (!update.status) {
                    <div class="col-auto">{{ update.type }}{{
                        update.physicalInspectionLocation === 'inspection_outlet' ? ' at inspection outlet' :
                          update.physicalInspectionLocation === 'customs_warehouse' ? ' at customs warehouse' : ''
                      }}
                    </div>
                  }
                </div>
              }
            </div>
          }
        }
      </div>
    </app-tooltip>
  }
}

@if (containerDischargeStatus(); as status) {
  <span class="mx-2">
        @switch (status) {
          @case ('in_progress') {
            <span class="fas fa-cog fa-spin text-secondary"
                  title="Currently being discharged"></span>
          }
          @case ('discharged') {
            <span class="fa fa-flag-checkered text-dark" title="Discharged"></span>
          }
          @case ('changed') {
            <span class="fa fa-flag-checkered text-danger"
                  title="Discharged but different than requested"></span>
          }
          @case ('overlanded') {
            <span class="badge text-bg-info align-text-bottom"
                  title="Discharged but not declared">Overlanded</span>
          }
          @case ('shortlanded') {
            <span class="badge text-bg-danger align-text-bottom"
                  title="Declared but not discharged">Shortlanded</span>
          }
        }
      </span>
}

@if (bulkDischarged()) {
  <span class="mx-2 fa fa-flag-checkered text-dark" title="Discharged"></span>
}

@if (containerEmpty()) {
  <span class="mx-2">
        <span class="badge text-bg-secondary align-text-bottom" title="Empty container">Empty</span>
      </span>
}

@for (process of customsProcess(); track process) {
  @if ('SEA_IN_SEA_OUT' === process) {
    <span class="fa fa-forward mx-2 text-info" title="Sea in sea out (Transhipment)"></span>
  }
  @if ('SEA_IN_SEA_OUT' !== process) {
    <span class="mx-1 text-center">
          <span class="badge rounded-pill text-bg-info align-text-bottom "
                [title]="utils.enumFormatter(process)">{{ utils.getCustomsProcessCode(process) }}</span>
        </span>
  }
}

@for (status of customsStatus(); track status) {
  <span class="mx-1 text-center">
        <span class="badge rounded-pill text-bg-dark align-text-bottom "
              [title]="utils.enumFormatter(status)">{{ utils.getCustomsStatusCode(status) }}</span>
      </span>
}

@if (dangerousCargo()) {
  <span class="fa fa-burn mx-2 text-danger" title="Cargo contains dangerous goods"></span>
}

@if (reefers()) {
  <span class="fa fa-thermometer-half mx-2 text-danger" title="Cargo is temperature controlled"></span>
}

@if (shortlandedCount(); as count) {
  <span class="mx-2 text-danger" title="{{count}} shortlanded container{{count > 1 ? 's' : ''}}"><span
    class="fa fa-balance-scale-left me-1"></span>{{ count }}</span>
}

@if (overlandedCount(); as count) {
  <span class="mx-2 text-danger" title="{{count}} overlanded container{{count > 1 ? 's' : ''}}"><span
    class="fa fa-balance-scale-right me-1"></span>{{ count }}</span>
}

@if (consignmentCount(); as count) {
  <span class="mx-2" title="{{count}} consignment{{count > 1 ? 's' : ''}}"><span
    class="fa fa-file-invoice me-1"></span>{{ count }}</span>
}

@if (packageCount(); as count) {
  <span class="mx-2" title="{{count}} package{{count > 1 ? 's' : ''}}"><span
    class="fa fa-box-open me-1"></span>{{ count }}</span>
}

@if (quantifiedWeight(); as weight) {
  <span class="mx-2" title="{{weight}} gross weight"><span class="fa fa-weight-hanging me-1"></span>{{ weight }}</span>
}

@if (containerCount(); as count) {
  <span class="mx-2" title="{{count}} container{{count > 1 ? 's' : ''}}"><span class="fa fa-cube me-1"></span><span
    class="text-start d-inline-block" style="min-width: 1.5rem">{{ count }}</span></span>
}
